import {GraphQLResolveInfo} from "graphql";
// import PrismaSelect from "../../utils/PrismaSelect"
import {PrismaSelect} from "@paljs/plugins"
import path from "path";
import {fromPairs} from "lodash/array";

const datamodel = require(path.join(process.cwd(), 'node_modules', '@prisma', 'client'));

export default (defaultFieldsMap) => (resolve, parent, args, context, info: GraphQLResolveInfo) => {
    const select = new PrismaSelect(info, {
        dmmf: [datamodel.dmmf],
        defaultFields: fromPairs(Object.keys(defaultFieldsMap).map(m => {
            return [m, (select) => {
                let fields = {};
                Object.keys(defaultFieldsMap[m]).forEach(f => {
                    if (select[f]) {
                        fields = PrismaSelect.mergeDeep(fields, defaultFieldsMap[m][f])
                    }
                })
                return fields;
            }]
        }))
    });
    context.select = select;
    if (Object.keys(select.value.select).length > 0) {
        args = {...args, ...select.value};

    }
    return resolve(parent, args, context, info);
}
